import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { FoodMoodDetailsPage, FoodMoodsPage } from './pages'

const FoodMoodsRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.MOBILE_APP_ONLY.subMenuItems.FOOD_MOODS.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={FoodMoodsPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.FOOD_MOODS_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={FoodMoodDetailsPage}
    />
  </Switch>
)

export default FoodMoodsRouter
